import { buildContext } from '@coveo/headless';

export function CoveoContext(headlessEngine) {
  if (headlessEngine) {
    const context = buildContext(headlessEngine);

    return context;
  }
  return null;
}
